import { SetHeaderService, UserId } from "@/helper/userHelper";
import service from "../baseHttpService";
class NotificationService {
  DoGetUnseenNotificationCount(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return service.peakNotificationAPI
      .get("/GetUnseenNotificationCount", { params: null, headers: headers })
      .then((res) => {
        return res;
      });
  }
  DoGetUnseenNotificationList(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return service.peakNotificationAPI.get("/GetUnseenNotificationList", { headers }).then((res) => {
      return res;
    });
  }
  DoGetSeenNotificationList(merchantId: number) {
    const headers: any = SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;

    return service.peakNotificationAPI.get("/GetSeenNotificationList", { headers }).then((res) => {
      return res;
    });
  }
  DoGetUnseenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService().headers;
    headers.notificationMerchantId = merchantId;
    const params = {
      id: notificationId,
    };
    return service.peakNotificationAPI.get("/GetUnseenNotification", { params, headers }).then((res) => {
      return res;
    });
  }
  DoDeleteSeenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return service.peakNotificationAPI.post("/DeleteSeenNotification", input, headers).then((res) => {
      return res;
    });
  }
  DoDeleteUnseenNotification(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return service.peakNotificationAPI.post("/DeleteUnseenNotification", input, headers).then((res) => {
      return res;
    });
  }
  DoSetNotificationIsSeen(merchantId: number, notificationId: string) {
    const headers: any = SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;
    const input = {
      id: notificationId,
    };
    return service.peakNotificationAPI.post("/SetNotificationIsSeen", input, headers).then((res) => {
      return res;
    });
  }
  DoSetAllNotificationIsSeen(merchantId: number) {
    const headers: any = SetHeaderService();
    headers.headers.notificationMerchantId = merchantId;

    return service.peakNotificationAPI.post("/SetAllNotificationIsSeen", null, headers).then((res) => {
      return res;
    });
  }
  DoUpdateAccessToken() {
    const headers = SetHeaderService();
    const input = {
      userId: UserId(),
    };
    return service.peakNotificationAPI.post("/UpdateAccessToken", input, headers).then((res) => {
      return res;
    });
  }
}

export default new NotificationService();
